import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Route, Switch, Redirect } from 'react-router';
import { withRouter } from 'react-router-dom';
import { Layout } from './components/Layout';

import { Setup } from './components/Setup';
import { NotFound } from './components/NotFound';

import { LoginPage } from './components/LoginPage';
import { AuthenticationCallback } from './components/AuthenticationCallback';

import { authenticationCentral } from './authentication/Authentication';

import { storage, SELECTED_APP, SELECTED_PROVIDER, TOKEN_INFO/*, EDITION*/ } from './app/Storage';
import { appManager } from './app/AppManager';
import { Edition } from './app/Edition';
import { customBusSchedManager } from './app/CustomBusSchedManager';
import { asyncComponent } from './app/AsyncComponent';
import { loadDataManager, loadBusSched, loadBusMap, loadSpiderMap, loadSchematicMap, prefetchModules } from './app/ModuleLoaders';
import { decode } from 'jsonwebtoken';

const Dashboard = asyncComponent(loadDataManager, 'Dashboard');
const Lanes = asyncComponent(loadDataManager, 'Lanes');
const ProviderLanes = asyncComponent(loadDataManager, 'ProviderLanes');
const ProviderPointsOfInterest = asyncComponent(loadDataManager, 'ProviderPointsOfInterest');
const Lines = asyncComponent(loadDataManager, 'Lines');
const Paths = asyncComponent(loadDataManager, 'Paths');
const Stops = asyncComponent(loadDataManager, 'Stops');
const PathStops = asyncComponent(loadDataManager, 'PathStops');
const MapPoints = asyncComponent(loadDataManager, 'MapPoints');
const Zones = asyncComponent(loadDataManager, 'Zones');
const ZoneTypes = asyncComponent(loadDataManager, 'ZoneTypes');
const Schedules = asyncComponent(loadDataManager, 'Schedules');
const PassingTimes = asyncComponent(loadDataManager, 'PassingTimes');
const DayTypes = asyncComponent(loadDataManager, 'DayTypes');
const SetOfDayTypes = asyncComponent(loadDataManager, 'SetOfDayTypes');
const Calendar = asyncComponent(loadDataManager, 'Calendar');
const Currencies = asyncComponent(loadDataManager, 'Currencies');
const FareProducts = asyncComponent(loadDataManager, 'FareProducts');
const Editions = asyncComponent(loadDataManager, 'Editions');
const LineColors = asyncComponent(loadDataManager, 'LineColors');
const Import = asyncComponent(loadDataManager, 'Import');
const Export = asyncComponent(loadDataManager, 'Export');
const Messages = asyncComponent(loadDataManager, 'Messages');
const ListDocuments = asyncComponent(loadDataManager, 'ListDocuments');
const Interfaces = asyncComponent(loadDataManager, 'Interfaces');

const GenerateSchedules = asyncComponent(loadBusSched, 'GenerateSchedules');
const ListSchedules = asyncComponent(loadBusSched, 'ListSchedules');
const DataUpdates = asyncComponent(loadBusSched, 'DataUpdates');
const SpineConfiguration = asyncComponent(loadBusSched, 'SpineConfiguration');
const GenericLayoutConfigurations = asyncComponent(loadBusSched, 'GenericLayoutConfigurations');

const NewBusMap = asyncComponent(loadBusMap, 'NewBusMap');
const ListBusMaps = asyncComponent(loadBusMap, 'ListBusMaps');
const BusMapSettings = asyncComponent(loadBusMap, 'BusMapSettings');

const SpiderMap = asyncComponent(loadSpiderMap, 'SpiderMap');
const ListSpiderMaps = asyncComponent(loadSpiderMap, 'ListSpiderMaps');
const SettingsSpiderMaps = asyncComponent(loadSpiderMap, 'SettingsSpiderMaps');

const SchematicMap = asyncComponent(loadSchematicMap, 'SchematicMap');
const ListSchematicMaps = asyncComponent(loadSchematicMap, 'ListSchematicMaps');
// Same component as GenericLayoutConfigurations. It loads from the schematicmap chunk, not from the bussched chunk.
const SchematicMapLayoutConfigurations = asyncComponent(loadSchematicMap, 'GenericLayoutConfigurations');

class App extends Component {
    static childContextTypes = {
        selectedApp: PropTypes.object,
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        selectProvider: PropTypes.func,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func,
        getOwnEdition: PropTypes.func,
        cleanEdition: PropTypes.func,
        editionsModifications: PropTypes.object,
        setEditionsModifications: PropTypes.func,
        setSelectedMenuItem: PropTypes.func,
        selectedMenuItem: PropTypes.string,
        setSelectedMenuItemTitle: PropTypes.func,
        selectedMenuItemTitle: PropTypes.string,
        showMetadataButton: PropTypes.bool,
        setShowMetadataButton: PropTypes.func
    }

    displayName = App.name
    nativeBusSched = ["SMTUC", "CARRIS"];

    constructor(props) {
        super(props);

        const selectedApp = appManager.getApp(storage.get(SELECTED_APP) || 'datamanager');
        const selectedProvider = storage.get(SELECTED_PROVIDER) || undefined;
        const edition = new Edition(() => this.updateEdition(), selectedProvider, false);
        // try {
        //     edition = Edition.fromJson(storage.get(EDITION), () => this.updateEdition());
        // }
        // catch (_) { }

        this.state = {
            loading: true,
            selectedApp: selectedApp,
            selectedProvider: selectedProvider,
            edition: edition,
            editionsModifications: null,
            setup: typeof authUrl !== 'undefined' && typeof apiDataManagerUrl !== 'undefined' && typeof apiBusSchedUrl !== 'undefined'
                && typeof apiBusMapUrl !== 'undefined' && typeof clientId !== 'undefined'
        };
    }

    componentDidMount() {
        if (!this.state.setup) {
            return;
        }

        authenticationCentral.loadData().then(() => {
            this.setState({
                loading: false
            }, () => {
                const { edition } = this.state;
                edition.update(new Date());

                this.schedulePrefetch();
            });
        });
    }

    // Downloads the code of the other modules of the user. Then a change of module does not wait for a download.
    schedulePrefetch() {
        if (!authenticationCentral.isLoggedIn || !authenticationCentral.tokenInfo.id_token) {
            return;
        }

        const idToken = decode(authenticationCentral.tokenInfo.id_token);
        if (null === idToken || !idToken.apps) {
            return;
        }

        setTimeout(() => prefetchModules(idToken.apps.split(';')), 3000);
    }

    getChildContext() {
        return {
            selectedApp: this.state.selectedApp,
            selectApp: (a, b) => this.setSelectedApp(a, b),
            selectedProvider: this.state.selectedProvider,
            selectProvider: (a, b) => this.setSelectedProvider(a, b),
            edition: this.state.edition,
            addEditionObserver: (a) => this.addEditionObserver(a),
            removeEditionObserver: (a) => this.removeEditionObserver(a),
            getOwnEdition: (a) => this.getOwnEdition(a),
            cleanEdition: () => this.cleanEdition(),
            editionsModifications: this.state.editionsModifications,
            setEditionsModifications: (a) => this.setEditionsModifications(a),
            setSelectedMenuItemTitle: (a) => this.setSelectedMenuItemTitle(a),
            setSelectedMenuItem: (a) => this.setSelectedMenuItem(a),
            selectedMenuItemTitle: this.state.selectedMenuItemTitle,
            selectedMenuItem: this.state.selectedMenuItem,
            showMetadataButton: this.state.showMetadataButton,
            setShowMetadataButton: (a) => this.setShowMetadataButton(a)
        };
    }

    setShowMetadataButton = (state) => {
        this.setState({ showMetadataButton: state });
    }

    setSelectedMenuItem = (menuItem) => {
        this.setState({ selectedMenuItem: menuItem });
    }

    setSelectedMenuItemTitle = (menuItemTitle) => {
        this.setState({ selectedMenuItemTitle: menuItemTitle });
    }

    setSelectedApp(app, redirect) {
        storage.set(SELECTED_APP, app);
        this.setState({
            selectedApp: appManager.getApp(app)
        });

        if (redirect) {
            this.props.history.push(`/${app}`);
        }
    }

    setSelectedProvider(provider, redirect) {
        // Update edition provider
        const { edition } = this.state;
        if (null !== edition) {
            edition.setProvider(provider);
        }

        // Update selected Provider
        storage.set(SELECTED_PROVIDER, provider);
        this.setState({
            selectedProvider: provider
        });

        if (redirect) {
            window.location.reload();
        }
    }

    addEditionObserver(component) {
        const { edition } = this.state;

        if (null === edition) {
            const { selectedProvider } = this.state;

            const newEdition = new Edition(() => this.updateEdition(), selectedProvider);
            newEdition.addObserver(component);

            this.setState({
                edition: newEdition
            }, () => {
                this.updateEdition();
            });
        }
        else {
            edition.addObserver(component);
        }
    }

    removeEditionObserver(component) {
        const { edition } = this.state;

        if (null !== edition) {
            edition.removeObserver(component);
        }
    }

    getOwnEdition(isToUpdate = true) {
        return new Edition(undefined, undefined, isToUpdate);
    }

    cleanEdition() {
        // storage.remove(EDITION);
        this.setState({
            edition: null
        });
    }

    setEditionsModifications(editionsModifications) {
        this.setState({
            editionsModifications: editionsModifications
        });
    }

    updateEdition() {
        // const { edition } = this.state;
        // storage.set(EDITION, Edition.toJson(edition));
    }

    render() {
        if (this.state.setup) {
            if (!this.state.loading) {
                if (authenticationCentral.isLoggedIn && !authenticationCentral.isTokenExpired && !authenticationCentral.shouldCheckSession) {
                    const { selectedApp } = this.state;
                    let startPageComponent;

                    switch (selectedApp.path) {
                        case "datamanager":
                        case "bussched":
                        case "busmap":
                        case "spidermap":
                        case "schematicmap":
                            startPageComponent = `/${selectedApp.path}`;
                            break;

                        default:
                            startPageComponent = "/notFound";
                            break;
                    }

                    let customBusSchedGenerator = false;
                    let customNativeBusSchedGenerator = false;

                    let customBusSchedGeneratorId = undefined;
                    let tokenInfo = storage.get(TOKEN_INFO);

                    if (typeof tokenInfo !== 'undefined') {
                        var json = JSON.parse(tokenInfo);
                        tokenInfo = Object.assign({}, json);
                    }

                    if (tokenInfo.id_token) {
                        let idToken = decode(tokenInfo.id_token);

                        customNativeBusSchedGenerator = this.nativeBusSched.includes(idToken.cbsg_id);
                        customBusSchedGenerator = idToken.cbsg === "True" && !this.nativeBusSched.includes(idToken.cbsg_id);

                        if (customBusSchedGenerator || customNativeBusSchedGenerator) {
                            customBusSchedGeneratorId = idToken.cbsg_id;
                        }
                    }

                    const generator = customBusSchedGenerator || customNativeBusSchedGenerator ? customBusSchedManager.getGenerator(customBusSchedGeneratorId) : GenerateSchedules;
                    const generatorConfigs = customBusSchedGenerator || customNativeBusSchedGenerator ? customBusSchedManager.getGeneratorConfigs(customBusSchedGeneratorId) : {};

                    return (
                        <Layout>
                            <Switch>
                                <Redirect exact from='/' to={startPageComponent} />
                                <Route path='/callback' component={AuthenticationCallback} />
                                <Route exact path='/datamanager' component={Dashboard} />
                                <Route path='/datamanager/dashboard' component={Dashboard} />
                                <Route path='/datamanager/lanes' component={Lanes} />
                                <Route path='/datamanager/providerLanes' component={ProviderLanes} />
                                <Route path='/datamanager/providerPointsOfInterest' component={ProviderPointsOfInterest} />
                                <Route path='/datamanager/lines' component={Lines} />
                                <Route path='/datamanager/paths' component={Paths} />
                                <Route path='/datamanager/stops' component={Stops} />
                                <Route path='/datamanager/pathstops' component={PathStops} />
                                <Route path="/datamanager/mapPoints" component={MapPoints} />
                                <Route path='/datamanager/zones' component={Zones} />
                                <Route path='/datamanager/zoneTypes' component={ZoneTypes} />
                                <Route path='/datamanager/schedules' component={Schedules} />
                                <Route path='/datamanager/dayTypes' component={DayTypes} />
                                <Route path='/datamanager/setOfDayTypes' component={SetOfDayTypes} />
                                <Route path='/datamanager/calendar' component={Calendar} />
                                <Route path='/datamanager/editions' component={Editions} />
                                <Route path='/datamanager/lineColors' component={LineColors} />
                                <Route path='/datamanager/passingTimes' component={PassingTimes} />
                                <Route path='/datamanager/import' component={Import} />
                                <Route path='/datamanager/export' component={Export} />
                                <Route path='/datamanager/currencies' component={Currencies} />
                                <Route path='/datamanager/fareProducts' component={FareProducts} />
                                <Route path='/datamanager/interfaces' component={Interfaces} />
                                <Route path='/datamanager/messages' component={Messages} />
                                <Route path='/datamanager/documents' render={(props) => <ListDocuments generatorConfigs={generatorConfigs} {...props} />} />
                                <Route exact path='/bussched' component={generator} />
                                <Route exact path='/bussched/schedules' component={generator} />
                                <Route path='/bussched/schedules/generate' component={generator} />
                                <Route path='/bussched/schedules/list' render={(props) => <ListSchedules generatorConfigs={generatorConfigs} {...props} />} />
                                <Route path='/bussched/updates' component={customBusSchedGenerator ? DataUpdates : null} />
                                <Route path='/bussched/spine' component={SpineConfiguration} />
                                <Route
                                    path="/bussched/layoutConfigurations"
                                    render={(props) =>
                                        !customBusSchedGenerator ||
                                            (customBusSchedGenerator && customBusSchedGeneratorId === "SMTUC") ? (
                                            <GenericLayoutConfigurations {...props} appName="bussched" />
                                        ) : null
                                    }
                                />
                                <Route path='/busmap/new' component={NewBusMap} />
                                <Route path='/busmap/list' component={ListBusMaps} />
                                <Route path='/busmap/settings' component={BusMapSettings} />
                                <Route exact path='/busmap' component={NewBusMap} />
                                <Route exact path='/spidermap' component={SpiderMap} />
                                <Route path='/spidermap/list' component={ListSpiderMaps} />
                                <Route path='/spidermap/settings' component={SettingsSpiderMaps} />
                                <Route exact path='/schematicmap' component={SchematicMap} />
                                <Route path='/schematicmap/list' component={ListSchematicMaps} />
                                <Route
                                    path="/schematicmap/layoutConfigurations"
                                    render={(props) => (
                                        <SchematicMapLayoutConfigurations {...props} appName="schematicmap" />
                                    )}
                                />
                                <Route path='*' component={NotFound} />
                            </Switch>
                        </Layout>
                    );
                } else {
                    return (
                        <div>
                            <Switch>
                                <Route exact path='/' component={LoginPage} />
                                <Route path='/callback' component={AuthenticationCallback} />
                                <Route path='*' component={LoginPage} />
                            </Switch>
                        </div>
                    );
                }
            } else {
                return (
                    <div />
                );
            }
        } else {
            return (
                <div>
                    <Route path='/' component={Setup} />
                </div>
            );
        }
    }
}

export default withRouter(App);
